import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { FeatureService } from '@unity/services/feature.service';
import { NavigationService } from '@unity/services/navigation.service';
import { InsideUnityRoute } from '@unity/utils/types';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard implements CanActivate {
  private readonly featureService = inject(FeatureService);
  private readonly navigationService = inject(NavigationService);

  public canActivate(route: ActivatedRouteSnapshot & InsideUnityRoute, _state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    const feature = route.data?.feature;
    if (!feature) {
      return true;
    }
    const isEnabled = this.featureService.isEnabled(feature);
    if (!isEnabled) {
      return this.navigationService.notFound();
    }
    return true;
  }
}
